export const cratLogoLink = 'https://explorer-testnet.cratd2csmartchain.io/assets/configs/network_logo.svg';
export const cratName = 'CRAT';
